// A new quote has no tabs - Details and Product show as sections of one page.
// Once saved, Details keeps both sections and Quotes lists the versions.
export const quoteEditTabs = [
  { label: "Details", value: "details" },
  { label: "Quotes", value: "quotes" },
];
